import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

// The back adds every activated planzone resource, or project member for a project group, not in the group yet.
function createInteractor(repository: Repository): Interactor {
  return ({ group, project }) =>
    present(
      repository
        .saveEveryoneInResourceGroup(group, project)
        .then((resources) => ({ group, resources }))
        .catch(() => Promise.reject({ group })),
    );
}

export type { Interactor };

export { createInteractor };
